module.exports = "/_next/static/images/truck7-7b39306680a8053e50e6ff5482e1e101.png.webp";